import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import ProjectHelper from 'src/app/helpers/project-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Project } from 'src/app/model/project/project';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { ClientCornerMapHelper } from '../helpers/client-corner-map-helper';

@Component({
  selector: 'client-corner-marker-popup',
  templateUrl: 'client-corner-marker-popup.component.html',
  styleUrls: ['./client-corner-marker-popup.component.scss'],
})
export class ClientCornerMarkerPopupComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  private static readonly HIDDEN_CLASS = 'hidden';

  @Input()
  projects: Project[];

  toggleDisplay = new Subject<number>();

  init: boolean = false;
  displayListClass: string = '';
  alwaysDisplay: boolean = false;

  ngOnInit(): void {
    if (this.projects.length > 1) {
      this.displayListClass = '';
      this.preprocessProjects();
    } else {
      this.displayListClass = ClientCornerMarkerPopupComponent.HIDDEN_CLASS;
    }
    this.alwaysDisplay = this.projects.length === 1;
    this.init = true;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.toggleDisplay != null) {
      this.toggleDisplay.complete();
    }
  }

  displayChild(index: number) {
    this.displayListClass = ClientCornerMarkerPopupComponent.HIDDEN_CLASS;
    this.toggleDisplay.next(index);
  }

  backPressed(): void {
    this.displayListClass = '';
  }

  private preprocessProjects(): void {
    this.projects.forEach((p) => {
      const subProject = ClientCornerMapHelper.getMostRecentSubProject(p);
      if (subProject == null) {
        return;
      }
      const displayProductList = CollectionHelper.isPopulated(p.products)
        ? StringHelper.join(
            p.products.map((prod) =>
              StringHelper.shortenText(ProductHelper.getTypeOf(prod), 30)
            ),
            ', '
          )
        : '';
      const displayPlacementDate =
        ProjectHelper.getDisplayPlacementDate(subProject);
      p.popupDisplay = StringHelper.join(
        ['#' + p.id.toString(), displayProductList, displayPlacementDate],
        ' - '
      );
    });
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}
